import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './NewPerson.html?raw';

import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import EntityExistCheck from '../../EntityExistCheck/EntityExistCheck';
import Edit from '../../../moreCore/UI/Edit/Edit';

class NewPerson extends compose(_uiFrameMixin, _StatefulSection) {
    templateString: any = template;

    private surname: MdsLax<InstanceType<typeof Edit>>;
    private salutation: MdsLax<InstanceType<typeof SelectBox>>;
    private professionalTitle: MdsLax<InstanceType<typeof SelectBox>>;
    private titlePrefix: MdsLax<InstanceType<typeof SelectBox>>;
    private titleSuffix: MdsLax<InstanceType<typeof SelectBox>>;

    private entityExistCheck: MdsLax<InstanceType<typeof EntityExistCheck>>;

    isValid(): boolean {

        if (!this.salutation.getValue()) return false;
        if (!this.surname.getValue()) return false;
        if (!this.entityExistCheck.isValid()) return false;
        return true;
    }

    private _onChangeInput(type: string, e: string) {
        this.setAttributeValue(type, e);

        switch (type) {
            case "name":
            case "name_first":

                let name = this.getAttributeValue("name");
                if (name) {
                    let name_first = this.getAttributeValue("name_first");
                    let attributes = {
                        name: name,
                        name_first: name_first
                    }
                    this.entityExistCheck.requestCheck("person", attributes);
                }
                break;
        }

        this.enableButton("save", this.isValid());
    }

    private _onClick_SaveBtn() {
        this.StandbyStart();

        let data = this.changedData;

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_QuickNew_SaveQuickNewPersonData",
            data,
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._showErrorMessage)
        );
    }
    private _onSaveResponse(person: { ID: string, gDisp_1: string }) {
        this.StandbyStop();

        this.showToast(this.translate("General_Notification_SaveSuccess"), "fas fa-check");

        this._emitReadyPersonData(person);
    }

    private _emitReadyPersonData(entity: { ID: string, gDisp_1: string}) {

        this.emit("NewPerson_Ready", entity);
        this.close();
    }

    private _entityExistCallback(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>) {

        this._emitReadyPersonData(rowGroup.entity);
    }

    private loadListValues() {
        this.setStartupState("loading");
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_QuickNew_LoadListData",
            {
                listsToLoad: ["salutation", "professionalTitle", "titlePrefix","titleSuffix"]
            },
            lang.hitch(this, this._loadListValues_Response),
            lang.hitch(this, this._showErrorMessage)
        );
    }
    private _loadListValues_Response(response) {

        for (let p in response) {

            let selectBox: MdsLax<InstanceType<typeof SelectBox>> = this[p];

            selectBox.setBlankOption("", "--", true);
            selectBox.setData("", response[p], "ID", p == "salutation" ? "description" : "description_short" );
        }

        this.setStartupState("ready");
        this.StandbyStop();
    }

    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        let msg;

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.createDefaultButton("save", lang.hitch(this, this._onClick_SaveBtn), false);

        this.StandbyStart();
        this.loadListValues();
        this.setTitles(this.translate("General_Label_NewPerson"), this.translate("General_Label_NewPerson"));

        this.entityExistCheck.setup({
            operationMode: "open",
            requestValidation: true,
            validWhenFound: false,
            entityListRowClickEnabled: true,
            entityListTableRowClickCallback: lang.hitch(this, this._entityExistCallback),
            listDlgSubtitle: this.translate("EntityExistCheck_FounEntriesList_Sub_NewContactPerson")
        });

        this.entityExistCheck.on("request_done", () => { this.enableButton("save", this.isValid()); });

        this.addOnchanged("name", lang.hitch(this, this._onChangeInput));
        this.addOnchanged("name_first", lang.hitch(this, this._onChangeInput));
        this.addOnchanged("ref_salutation", lang.hitch(this, this._onChangeInput));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NewPerson);